module.exports = __webpack_public_path__ + "media/images/flags/4x3/svk-fd95226265fa2e97773dcf00b5cbe952.svg";